export const AUTH_USER = "AUTH_USER";
export const AUTH_ERROR = "AUTH_ERROR";
export const DEAUTH = "DEAUTH";
export const DETECT_WARNING_MACHINE = "DETECT_WARNING_MACHINE";
export const SIGNUP = "SIGNUP";
export const SIGNUP_ERR = "SIGNUP_ERR";
export const SET_FB_RESPONSE = "SET_FB_RESPONSE";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_ERR = "CHANGE_PASSWORD_ERR";
export const REQUEST_FORGOT_PASSWORD = "REQUEST_FORGOT_PASSWORD";
export const REQUEST_FORGOT_PASSWORD_ERR = "REQUEST_FORGOT_PASSWORD_ERR";
export const UPDATE_FORGOT_PASSWORD = "UPDATE_FORGOT_PASSWORD";
export const UPDATE_FORGOT_PASSWORD_ERR = "UPDATE_FORGOT_PASSWORD_ERR";
export const INITIATE_SIGNIN = "INITIATE_SIGNIN";
export const REGISTER_DEVICE = "REGISTER_DEVICE";